<top-banner variant="logo"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">

    <div *ngIf="needsCerts" class="cards-flex-row">
      <dashboard-card title="" [loading]="false">
        <div class="temporary-information-message">
          <div>
            <i class="fas fa-info-circle"></i>
          </div>
          <div>
            <p>Some site operators require confirmation of certificates before allowing workers on site. Please check below and submit any pending certificates for approval</p>
          </div>
        </div>
      </dashboard-card>
    </div>

    <div class="cards-flex-row">
      <div style="flex: 1" class="cards-flex-column">
        <dashboard-card *ngIf="hasPowerStationOwnerRelation" style="flex: 1" title="Pending Outage Agreements" [loading]="false">
          <div class="d-flex flex-column justify-content-between">
            <div class="large-number-display-wrapper">
              <large-number-display
                  [number]="contractorCourseNeedsAttentionCount"
                  [text]="'agreement' | plural: contractorCourseNeedsAttentionCount"
                  [class]="contractorCourseNeedsAttentionCount > 0 ? 'yellow' : 'green-outline disabled'"
                  (onClick)="contractorCourseNeedsAttentionCount > 0 ? goToOutages() : false">
              </large-number-display>
            </div>
          </div>
        </dashboard-card>

        <dashboard-card style="flex: 1" title="Workers" [loading]="false">
          <div class="d-flex flex-column justify-content-between">
            <div class="large-number-display-wrapper">
              <large-number-display [number]="totalWorkers" [text]="'workers'" [class]="'green-outline'" (onClick)="goToWorkers()">
              </large-number-display>
            </div>
          </div>
        </dashboard-card>
      </div>

      <dashboard-card style="flex: 3" [title]="'Pending Company Certificates'" [loading]="false">
        <p *ngIf="!certificates.length">
          <br>
          <i class="fas fa-check-circle success"></i>
          All company certificates are up to date
        </p>
        <p-table *ngIf="certificates.length" [value]="certificates" [autoLayout]="true">
          <ng-template pTemplate="header">
            <tr>
              <th>Type</th>
              <th>Status</th>
              <th>Site Owner</th>
              <th>Expiry Date</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-comp>
            <tr [pSelectableRow]="comp">
              <td>{{ comp.competencyType.value }}</td>
              <td>
                <span *ngIf="comp.status === 'PENDING'" class="badge badge-pill badge-warning">Required</span>
                <span *ngIf="comp.status === 'EXPIRED'" class="badge badge-pill badge-danger">Expired</span>
                <span *ngIf="comp.status === 'SUBMITTED'" class="badge badge-pill badge-primary">Submitted</span>
                <span *ngIf="comp.status === 'APPROVED' && !comp.nearExpiry" class="badge badge-pill badge-success">Approved</span>
                <span *ngIf="comp.status === 'APPROVED' && comp.nearExpiry" class="badge badge-pill badge-warning">Expires Soon</span>
                <span *ngIf="comp.status === 'REJECTED'" class="badge badge-pill badge-danger">Rejected</span>
              </td>
              <td>{{ comp.siteOwnerName }}</td>
              <td>{{ comp.expiryDate | date: 'MMM d, y' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="5">No certificates found</td>
            </tr>
          </ng-template>
        </p-table>
        <div>
          <a class="btn btn-success btn-round float-right mt-5" [routerLink]="['/' + routeRole, 'company', 'certificates']">Manage Certificates</a>
        </div>
      </dashboard-card>
    </div>

  </div>
</div>
